var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-6 selectHeader"},[_c('select',{staticClass:"form-control",attrs:{"id":"lang-setter","name":"language-setter"},domProps:{"value":_vm.lang},on:{"change":_vm.onLangChange}},[_c('option',{attrs:{"value":"pl"}},[_vm._v(" PL ")]),_c('option',{attrs:{"value":"en"}},[_vm._v(" EN ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }